import { render, staticRenderFns } from "./ResultsTrivia2.vue?vue&type=template&id=2b1ff362"
import script from "./ResultsTrivia2.vue?vue&type=script&lang=js"
export * from "./ResultsTrivia2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports